import PublicPage from "domain/public";
import { isBaseSolutionRoute } from "helpers/baseSolutionRoutes";
import {
  GlobalStyles as IParqueGlobalStyles,
  ToastContainer,
} from "iparque-components";
import AppProvider from "providers/AppProvider";
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import defaultTheme from "theme/defaultTheme";
import { GlobalStyles } from "theme/globalStyles";
import { setMetaDescription } from "utils/dom";

if (process.env.REACT_APP_GOOGLE_ANALYTICS_4_TRACKING_ID) {
  ReactGA.initialize(
    process.env.REACT_APP_GOOGLE_ANALYTICS_4_TRACKING_ID as string
  );
}

const App: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (!isBaseSolutionRoute(location.pathname)) {
      return;
    }

    document.title =
      t(
        "10694"
      ) /* iParque OnStreet – Gestão de Estacionamento para concessionárias */;

    setMetaDescription(
      t(
        "10695"
      ) /* Controlo e monitorização de zonas, ruas e equipas de fiscalização. A solução para a sua concessionária! */
    );
  }, [location, t]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <IParqueGlobalStyles />
      <GlobalStyles />
      <AppProvider>
        <PublicPage />
      </AppProvider>
      <ToastContainer />
    </ThemeProvider>
  );
};

export default App;
